import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/jiangzhaung.png'


const _withScopeId = n => (_pushScopeId("data-v-65b24423"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container_content" }
const _hoisted_3 = { class: "content_warn" }
const _hoisted_4 = { class: "content_watch" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "watch_head" }, "观看页域名定制", -1))
const _hoisted_6 = { class: "watch_text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "域名设置:", -1))
const _hoisted_8 = { class: "text_input" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wchat_head" }, "微信登录定制", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wchat_tip" }, "1.获取服务号信息", -1))
const _hoisted_11 = { class: "watch_text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "apiAppId(应用ID):", -1))
const _hoisted_13 = { class: "text_input" }
const _hoisted_14 = { class: "watch_text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "apiAppSecret(应用密钥):", -1))
const _hoisted_16 = { class: "text_input" }
const _hoisted_17 = { class: "watch_text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "消息模板(ID):", -1))
const _hoisted_19 = { class: "text_input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wchat_tip" }, "2.配置服务号信息", -1))
const _hoisted_21 = { class: "watch_text" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "网页授权域名:", -1))
const _hoisted_23 = {
  class: "text_copy",
  id: "warrants"
}
const _hoisted_24 = ["data-clipboard-text"]
const _hoisted_25 = { class: "watch_text" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_heads" }, "IP白名单:", -1))
const _hoisted_27 = {
  class: "textarea_input test",
  id: "roster"
}
const _hoisted_28 = ["data-clipboard-text"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wchat_head" }, "微信支付通道定制", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wchat_point" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2F",
    target: "_blank"
  }, "前往微信商户平台"),
  /*#__PURE__*/_createTextVNode("  下载证书，并在下方上传 ")
], -1))
const _hoisted_31 = { class: "watch_txt" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "微信支付证书(apiclient_cert.pem):", -1))
const _hoisted_33 = { class: "text_load" }
const _hoisted_34 = { class: "text_inputs" }
const _hoisted_35 = { class: "text_book" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "watch_txt" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "微信证书密钥(apiclient_key.pem):", -1))
const _hoisted_40 = { class: "text_load" }
const _hoisted_41 = { class: "text_inputs" }
const _hoisted_42 = { class: "text_book" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wchat_tip" }, "1.获取商户信息", -1))
const _hoisted_46 = { class: "watch_text" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "payAppId(公众号AppId):", -1))
const _hoisted_48 = { class: "text_input" }
const _hoisted_49 = { class: "watch_text" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "payPartnerKey(支付密钥):", -1))
const _hoisted_51 = { class: "text_input" }
const _hoisted_52 = { class: "watch_text" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "payMchld(商户号):", -1))
const _hoisted_54 = { class: "text_input" }
const _hoisted_55 = { class: "watch_text" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "payMchName(商户名称):", -1))
const _hoisted_57 = { class: "text_input" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wchat_head" }, "配置商户信息", -1))
const _hoisted_59 = { class: "watch_text" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, "支付授权目录:", -1))
const _hoisted_61 = {
  class: "text_copy",
  id: "listones"
}
const _hoisted_62 = ["data-clipboard-text"]
const _hoisted_63 = { class: "watch_text" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text_head" }, null, -1))
const _hoisted_65 = {
  class: "text_copy",
  id: "copy"
}
const _hoisted_66 = ["data-clipboard-text"]
const _hoisted_67 = { class: "footer_btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_upload_outlined = _resolveComponent("upload-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_alert, {
          type: "warning",
          class: "warn_content",
          message: "该页面配置需要由平台技术人员协助您完成，请勿随意填写，以免影响您的正常使用。",
          banner: "",
          closable: ""
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.realm,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.obj.realm) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.apiId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.obj.apiId) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.apiSecret,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.obj.apiSecret) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.messagePlate,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.obj.messagePlate) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.domain), 1),
          _createElementVNode("div", {
            class: "text_btn warrant",
            "data-clipboard-text": _ctx.domain,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.Copylist('.warrant')))
          }, [
            _createVNode(_component_a_button, { class: "text_clone" }, {
              default: _withCtx(() => [
                _createTextVNode("复制")
              ]),
              _: 1
            })
          ], 8, _hoisted_24)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("pre", null, _toDisplayString(_ctx.whitelList), 1)
          ]),
          _createElementVNode("div", {
            class: "text_btns rose",
            "data-clipboard-text": _ctx.whitelList,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copy(_ctx.whitelList)))
          }, [
            _createVNode(_component_a_button, { class: "text_clone" }, {
              default: _withCtx(() => [
                _createTextVNode("复制")
              ]),
              _: 1
            })
          ], 8, _hoisted_28)
        ]),
        _hoisted_29,
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_a_upload, {
                class: "text_upload",
                "file-list": _ctx.fileList,
                "onUpdate:fileList": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fileList) = $event)),
                name: "file",
                action: "/api/v1/live/wx_pay_certificate",
                headers: { token: _ctx.token },
                onChange: _ctx.wxpaycertificate,
                accept: ".pem",
                "show-upload-list": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_upload_outlined),
                      _createTextVNode(" 上传文件 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["file-list", "headers", "onChange"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_35, _hoisted_37, 512), [
              [_vShow, _ctx.ishow]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_a_upload, {
                class: "text_upload",
                value: _ctx.obj.certificatele,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.obj.certificatele) = $event)),
                name: "file",
                action: "/api/v1/live/wx_payment_key_upload",
                headers: { token: _ctx.token },
                onChange: _ctx.wxPaymentKeyUpload,
                accept: ".pem",
                "show-upload-list": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_upload_outlined),
                      _createTextVNode(" 上传文件 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "headers", "onChange"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_42, _hoisted_44, 512), [
              [_vShow, _ctx.shows]
            ])
          ])
        ]),
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.payId,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.obj.payId) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.payKey,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.obj.payKey) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.paymchid,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.obj.paymchid) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_a_input, {
              value: _ctx.obj.payname,
              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.obj.payname) = $event)),
              placeholder: "",
              size: "large"
            }, null, 8, ["value"])
          ])
        ]),
        _hoisted_58,
        _createElementVNode("div", _hoisted_59, [
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.payDir), 1),
          _createElementVNode("div", {
            class: "text_btn listone",
            "data-clipboard-text": _ctx.payDir,
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.Copylist('.listone')))
          }, [
            _createVNode(_component_a_button, { class: "text_clone" }, {
              default: _withCtx(() => [
                _createTextVNode("复制")
              ]),
              _: 1
            })
          ], 8, _hoisted_62)
        ]),
        _createElementVNode("div", _hoisted_63, [
          _hoisted_64,
          _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.paysDir), 1),
          _createElementVNode("div", {
            class: "text_btn listtwo",
            "data-clipboard-text": _ctx.paysDir,
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.Copylist('.listtwo')))
          }, [
            _createVNode(_component_a_button, { class: "text_clone" }, {
              default: _withCtx(() => [
                _createTextVNode("复制")
              ]),
              _: 1
            })
          ], 8, _hoisted_66)
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.keep
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}